import React, { Component } from 'react';
import { Modal, Button, Dropdown, DropdownButton, OverlayTrigger,Tooltip} from "react-bootstrap";
import { InfoCircleFill } from 'react-bootstrap-icons';
import { Link45deg } from 'react-bootstrap-icons';

import { FileEarmarkText,  House } from 'react-bootstrap-icons';

import CircularProgress from '@material-ui/core/CircularProgress';
import withStyles from '@material-ui/core/styles/withStyles';

import CurrencyInput from '../types/CurrencyInput'

import 'react-tabs/style/react-tabs.css';

import CustomizedSlider from '../types/CustomizedSlider';

import homebuyer from '../pages/img/icons/homebuyer.png';
import flipper from '../pages/img/icons/flipper.png';
import rental from '../pages/img/icons/rental.png';
import realtor from '../pages/img/icons/realtor.png';
import other from '../pages/img/icons/other.png';

import { authMiddleWare } from '../utilities/Auth';

import Dialog from 'react-bootstrap-dialog'

import axios from 'axios';


const styles = (theme) => ({
	content: {
		flexGrow: 1,
		padding: theme.spacing(3)
	},
	toolbar: theme.mixins.toolbar,
	root: {
		minWidth: 300
	},
	uiProgess: {
		position: 'fixed',
		zIndex: '1000',
		height: '31px',
		width: '31px',
		left: '40%',
		top: '35%'
	}
});

class InvestorTypeDialog extends Component { 


  /* Actual one for application */

    state = {
        isOpen: false,
        uiSaving: false,
        investorType:'',
        user:null,
        parentRef:null
      };
   
      openModal = () => this.setState({ isOpen: true });
      closeModal = () => this.setState({ isOpen: false });

    constructor(props) {
        super(props);

        this.mainModalInfoDialogRef = React.createRef();

     }

     componentDidUpdate() 
     {

     }

    componentDidMount() {
        //alert(window.innerWidth);
    }

    componentWillUnmount() {
    }


    PopulateDialog(user,parentRef)
    {
        
        this.ClearFields();

        this.setState({
          user: user,
          parentRef:parentRef
        });
      
 
        this.openModal();
        
    }

 
    ClearFields()
    {
      this.setState({
          investorType:''
        });

    }


    selectInvestorType= (event) => {

    
       const radioElement = document.getElementById(event.target.name);
 
       radioElement.checked = true;
 
       this.setState({
         investorType: event.target.name
       });
 
   };

   onChangeValue= (event) => {
 
   
     this.setState({
       investorType: event.target.value
     });
 
   };

  submit= (event) => {
    event.preventDefault();
   	

    if (this.state.investorType ==='')
    {

      this.dialog.show({
        title: 'Invalid Selection',
        body: 'You must select one of the options',
        actions: [
          Dialog.OKAction(() => {
            
          })
        ],
        bsSize: 'small',
        onHide: (dialog) => {
          dialog.hide()
          
        }
      })

    } else {

        const payload = {
          investorType: this.state.investorType
        }

        this.setState({
          uiSaving: true
        });

        authMiddleWare(this?.props?.history);
        const authToken = localStorage.getItem('AuthToken');
        const refreshToken = localStorage.getItem('RefreshToken');
        axios.defaults.headers.common = { Authorization: `${authToken}`,RefreshToken:refreshToken };
        
        axios
          .post('/api/updateInvestorType', payload)
          .then((response) => {
            
            if (response.headers["authtoken"] != null && response.headers["authtoken"] != "" && response.headers["refreshtoken"] != null && response.headers["refreshtoken"] !="")
            {
                localStorage.setItem('AuthToken', `Bearer ${response.headers["authtoken"]}`); //We need to set them again on each request in case they got refresh to keep user logged in all the time
                localStorage.setItem('RefreshToken', response.headers["refreshtoken"]); //We need to set them again on each request in case they got refresh to keep user logged in all the time
            }


            this.setState({
              uiSaving: false
            });

            this.closeModal();
            this.state.parentRef.investorTypeDialogDidComplete(this.state.investorType);

          })
          .catch((error) => {
            console.log(error);

              if (error && error.response && error.response.status && error.response.status === 403) {
                      localStorage.setItem('SessionExpired',"Y");
                      //window.location.reload();
                      window.location.href = '/login';
              } else 
              {
                this.setState({
                  uiSaving: false
                });
      
              }
            
          });
     
      }

	};


  render() {

    const { classes } = this.props;


      //Note: backdrop="static"  prevents the modal from closing when you click outside
      return (
      
          <Modal size="lg" show={this.state.isOpen} onHide={this.closeModal} backdrop="static" dialogClassName="property-edit-modal-width"> 

           {/* <Modal.Header closeButton> */}
            <Modal.Header>
              <Modal.Title>

         
                <span>About You</span>
             

              </Modal.Title>
            </Modal.Header>
            <Modal.Body class="alert-edit-modal" ref={this.mainModalInfoDialogRef}>
            
              <div class="modal-body" style={{padding:"0px",margin:"0px"}}>
                    <div classx="container" style={{padding:"0px",margin:"0px"}}>

                    <div class="card2">
                        <div class="card-body alert-edit-modal" style={{backgroundColor:'#FFFFFF'}}>

                            <div style={{paddingBottom:'15px',fontSize:'20px'}}>
                           What best describes you?
                            </div> 

                            <div class="row">

                                {/* HOME BUYER */}
                                <div class="col-md-3" style={{textAlign:'center'}}>
                             
                                      <div style={{fontSize:'20px',fontWeight:'bold'}}>
                                        &nbsp;
                                        <br></br>
                                      HOME BUYER
                                      </div>
                                      <OverlayTrigger
                                          placement="auto"
                                          delay={{ show: 150, hide: 100 }} 
                                          trigger={["hover","click"]}
                                          overlay={<Tooltip id="indicatorInfoTooltip" className="messagetooltip">
                                        
                                        <div className='helpText'>A person looking to buy <br></br>a house to live in it <br></br>as their primary home.</div>
                                          
                                        </Tooltip>}
                                        >
                                      
                                      <img src={homebuyer} style={{height:'160px'}} name="homebuyer" onClick={this.selectInvestorType}/>
                                    
                                      </OverlayTrigger>
                                      <br></br>
                                      <input type="radio" value="homebuyer" id="homebuyer" name="investorType" style={{height:'30px',width:'30px',marginTop:'10px'}} onChange={this.onChangeValue}/>
                              
                                </div>

                                {/* HOUSE FLIPPING INVESTOR */}
                                <div class="col-md-3" style={{textAlign:'center'}}>

                                    <div style={{fontSize:'20px',fontWeight:'bold'}}>
                                    HOUSE FLIPPING INVESTOR
                                    </div>
                                    <OverlayTrigger
                                        placement="auto"
                                        delay={{ show: 150, hide: 100 }} 
                                        trigger={["hover","click"]}
                                        overlay={<Tooltip id="indicatorInfoTooltip" className="messagetooltip">
                                      
                                          <div className='helpText'>A person looking to buy <br></br>houses to fix them up <br></br> and resell them for a profit.</div>
                                        
                                      </Tooltip>}
                                      >
                                    
                                    <img src={flipper} name="flipper" style={{height:'160px'}} onClick={this.selectInvestorType}/>
                                  
                                    </OverlayTrigger>
                                    <br></br>
                                    <input type="radio" value="flipper" id="flipper" name="investorType" style={{height:'30px',width:'30px',marginTop:'10px'}} onChange={this.onChangeValue}/>
                                     
                                  </div>

                                {/* RENTAL PROPERTY INVESTOR */}
                                <div class="col-md-3" style={{textAlign:'center'}}>

                                    <div style={{fontSize:'20px',fontWeight:'bold'}}>
                                    RENTAL PROPERTY INVESTOR
                                    </div>
                                    <OverlayTrigger
                                        placement="auto"
                                        delay={{ show: 150, hide: 100 }} 
                                        trigger={["hover","click"]}
                                        overlay={<Tooltip id="indicatorInfoTooltip" className="messagetooltip">
                                      
                                          <div className='helpText'>A person looking to buy <br></br>properties to rent to others<br></br> for income.</div>
                                        
                                      </Tooltip>}
                                      >
                                    
                                    <img src={rental} style={{height:'160px'}} name="rental" onClick={this.selectInvestorType}/>
                                  
                                    </OverlayTrigger>
                                    <br></br>
                                    <input type="radio" value="rental" id="rental" name="investorType" style={{height:'30px',width:'30px',marginTop:'10px'}} onChange={this.onChangeValue}/>
                                     
                                  </div>

                                {/* REALTOR */}
                                <div class="col-md-3" style={{textAlign:'center'}}>

                                    <div style={{fontSize:'20px',fontWeight:'bold'}}>
                                    REALTOR /
                                      <br></br>
                                    BANKER
                                    </div>
                                    <OverlayTrigger
                                        placement="auto"
                                        delay={{ show: 150, hide: 100 }} 
                                        trigger={["hover","click"]}
                                        overlay={<Tooltip id="indicatorInfoTooltip" className="messagetooltip">
                                      
                                          <div className='helpText'>A person who finds or assesses properties <br></br>for other people to buy or sell.</div>
                                        
                                      </Tooltip>}
                                      >

                                    <img src={realtor} style={{height:'160px'}} name="realtor" onClick={this.selectInvestorType}/>

                                    </OverlayTrigger>
                                    <br></br>
                                    <input type="radio" value="realtor" id="realtor" name="investorType" style={{height:'30px',width:'30px',marginTop:'10px'}} onChange={this.onChangeValue}/>
                                    
                                    </div>

                                {/* OTHER 
                                <div class="col-md-3" style={{textAlign:'center'}}>

                                  <div style={{fontSize:'20px',fontWeight:'bold'}}>
                                    &nbsp;
                                    <br></br>
                                    OTHER
                                  </div>
                                 
                                  <img src={other} style={{height:'160px'}}/>

                                  <br></br>
                                  <input type="radio" value="other" name="investorType" style={{height:'30px',width:'30px',marginTop:'10px'}} onChange={this.onChangeValue}/>

                                  </div>
                              */}

                            </div>

                        </div>
                        
                    </div>
              </div> 

        
                    <div class="modal-footer"  style={{backgroundColor:'#FFFFFF'}}>
                                            <div class="container">
                                            <center>
                                                <div class="row">
                                                    <div class="col-md-5">&nbsp;</div>
                                                    <div class="col-md-2">
                                                      <button id="SaveButton" type="button" class="btn btn-primary btn-block footer-buttons" style={{marginTop:"5px"}} onClick={this.submit}  >Continue</button>
                                                    </div>
                                                
                                                    <div class="col-md-6">&nbsp;</div>
                                                  </div>
                                              </center>

                                            </div>




                    </div>

                    <Dialog ref={(component) => { this.dialog = component }}/>                
            </div>
                                                    
            </Modal.Body>
            {/*
            <Modal.Footer>
              <Button variant="secondary" onClick={this.closeModal}>Close</Button>
            </Modal.Footer>
            */}

            {this.state.uiSaving && 
              <main className={classes.content} style={{height:'1px'}}>
                  <div className={classes.toolbar} />
                  {this.state.uiSaving && <CircularProgress size={150} className={classes.uiProgess} />}
              </main>
            }    

          </Modal>
   
      );
      
    }
}

export default (withStyles(styles)(InvestorTypeDialog));